/**
 * @generated SignedSource<<3ab63b42ad0fe21c488994dfd731cacf>>
 * @relayHash 9f966c5ad5bb58793dc9d476443332d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7cc5278a5c190b32f2f1d8e09ad7251d584ba4e49ceb47d7c4ca39c035b0e8b6

import type { ConcreteRequest } from 'relay-runtime';
export type PageTreeMacroExcerptBatchQuery$variables = {
  after?: string | null;
  first: number;
  ids: ReadonlyArray<string>;
};
export type PageTreeMacroExcerptBatchQuery$data = {
  readonly content: {
    readonly count: number | null;
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly atlas_doc_format: {
          readonly mediaToken: {
            readonly token: string | null;
          } | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly macroExcerpt: {
        readonly atlasDocFormat: string | null;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
};
export type PageTreeMacroExcerptBatchQuery = {
  response: PageTreeMacroExcerptBatchQuery$data;
  variables: PageTreeMacroExcerptBatchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ids"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      },
      {
        "kind": "Literal",
        "name": "type",
        "value": "page"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "count"
      },
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          },
          {
            "kind": "ScalarField",
            "name": "endCursor"
          }
        ]
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ConfluenceMacroExcerptBody",
            "kind": "LinkedField",
            "name": "macroExcerpt",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "fallbackToBody",
                    "value": false
                  }
                ],
                "kind": "ScalarField",
                "name": "atlasDocFormat",
                "storageKey": "atlasDocFormat(fallbackToBody:false)"
              }
            ]
          },
          {
            "concreteType": "ContentBodyPerRepresentation",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "atlas_doc_format",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "EmbeddedMediaToken",
                    "kind": "LinkedField",
                    "name": "mediaToken",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "token"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageTreeMacroExcerptBatchQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageTreeMacroExcerptBatchQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "9f966c5ad5bb58793dc9d476443332d3",
    "id": "7cc5278a5c190b32f2f1d8e09ad7251d584ba4e49ceb47d7c4ca39c035b0e8b6",
    "metadata": {},
    "name": "PageTreeMacroExcerptBatchQuery",
    "operationKind": "query",
    "text": "query PageTreeMacroExcerptBatchQuery($ids:[ID!]!,$first:Int!,$after:String){content(ids:$ids,first:$first,after:$after,type:\"page\"){count,pageInfo{hasNextPage,endCursor},nodes{id,macroExcerpt{atlasDocFormat(fallbackToBody:false)},body{atlas_doc_format{mediaToken{token}}}}}}"
  }
};
})();

(node as any).hash = "b191180b54dd635cfaede7c7980cc5e4";

export default node;
